import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import Modal from '../../../uiKit/Modal'
import { hasPermissionForBot } from '../../../security'
import ShareModal from './ShareModal'
import CloneModal from './NewBotModal'

/**
 * Per-row actions for the organisations list.
 *
 * Clone and Share were previously only reachable from the grid/card view
 * (BotPlate). The list is the primary view of the CareBrain home, so the same
 * two operations live here too, backed by the same modals (ShareModal and the
 * clone mode of NewBotModal) and gated by the same `shareBot` permission.
 */
const styles = () => ({
  actions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'var(--careco-space-md, 16px)',
  },
  action: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    cursor: 'pointer',
    fontFamily: 'var(--careco-font)',
    fontSize: 13,
    fontWeight: 600,
    color: 'var(--careco-primary)',
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    '&:hover': { color: 'var(--careco-primary-hover)' },
    '&:focus-visible': {
      outline: '2px solid var(--careco-primary)',
      outlineOffset: 2,
    },
  },
  none: {
    fontSize: 14,
    color: 'var(--careco-text-muted)',
  },
})

class OrganisationRowActions extends React.Component {
  state = {
    // 'share' | 'clone' | null
    modal: null,
  }

  open = modal => this.setState({ modal })

  close = () => this.setState({ modal: null })

  render() {
    const { classes, row } = this.props
    const { modal } = this.state
    const bot = row.bot

    // An operator who cannot share the organisation cannot clone it either — the
    // backend rejects both — so the cell is a dash rather than dead controls.
    if (!hasPermissionForBot(row.id, 'shareBot')) {
      return <span className={classes.none}>—</span>
    }

    return (
      <>
        <span className={classes.actions}>
          <button type="button" className={classes.action} onClick={() => this.open('clone')}>
            Clone
          </button>
          <button type="button" className={classes.action} onClick={() => this.open('share')}>
            Share
          </button>
        </span>

        <Modal open={modal === 'share'} tabIndex="-1" onClose={this.close} title="Share organisation">
          <ShareModal bot={bot} closeModal={this.close} />
        </Modal>

        <Modal open={modal === 'clone'} tabIndex="-1" onClose={this.close} title="Clone organisation">
          <CloneModal
            buttonName="Clone"
            botId={row.id}
            botName={`Copy of ${row.name}`}
            aiModel={bot.odinConfigs && bot.odinConfigs.aiModel}
            onClose={this.close}
            onCloned={this.props.onCloned}
          />
        </Modal>
      </>
    )
  }
}

OrganisationRowActions.propTypes = {
  classes: PropTypes.object,
  row: PropTypes.object.isRequired,
  onCloned: PropTypes.func,
}

export default withStyles(styles)(OrganisationRowActions)
